import { React, useEffect, useState, ChangeEvent } from 'react';
import { Grid, Column, Loading, IconButton, FormGroup, Button, InlineNotification, TextInput, Content, DatePicker, DatePickerInput } from '@carbon/react';
import RecibosTable from './RecibosTable';
import { useTranslation } from 'react-i18next';
import { DocumentPdf, Xml } from '@carbon/react/icons';
import dayjs from "dayjs";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const Recibos = () => {

  if (!sessionStorage.getItem('rfc') || !cookies.get('rfc')) {
    window.location.href = "/#/";
  }

  const [t, i18n] = useTranslation("translations");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const rfcLogin = sessionStorage.getItem('rfc');
  const [mostrarMsg, setMostrarMsg] = useState([]);
  const [isOtrosRecibos, setIsOtrosRecibos] = useState(false);
  const [txtRfc, setTxtRfc] = useState('');
  

  const hideMesg = () => {
    setMostrarMsg({ "showMsg": 0 });
}

  var CR = {
    ColorHrLine: ({ color }) => (<hr style={{ color: color, backgroundColor: color, height: 2 }} />),
    getHeaders: function () {
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      return headers;
    },
    llenarTablaRecibos: async function () {
      setLoading(true);
      
      let feInicio = document.getElementById('dpStart').value;
      let feFin = document.getElementById('dpFinish').value;
      var strRFC = "";
      if(isOtrosRecibos){
        strRFC = txtRfc;
      } else {
        strRFC = rfcLogin;
      }

      const response = await fetch(process.env.REACT_APP_URL_SERVICE_CFDI_EMPLEADOS+"?rfc="+strRFC+"&fechaPagoInicial="+feInicio+"&fechaPagoFinal="+feFin, {
                                method: "GET",
                                headers: CR.getHeaders(),
                              });
      const data = await response.json();    

      if(data.exito){
          var resp = data.data;
          let cont = 0;
          var arrTableRec = resp;
          var reformattedTableRec = arrTableRec.map(function (data) {
            var rObj = {};
            rObj["id"] = ++cont;
            rObj["xml"] = <IconButton kind="secondary--tertiary">
                            <Xml  onClick={() => { CR.imprimirRecibo(data.Uuid, "xml") }} />
                          </IconButton>;
            rObj["pdf"] = <IconButton kind="secondary--tertiary">
                            <DocumentPdf onClick={() => { CR.imprimirRecibo(data.Uuid, "pdf") }} />
                          </IconButton>;
            rObj["fePago"] = data.FechaPago;
            rObj["rfcEmpleado"] = data.RfcReceptor;
            rObj["empleado"] = data.NombreReceptor;
            rObj["numEmpleado"] = data.NumEmpleado;
            rObj["tipoNom"] = data.TipoNomina;
            rObj["feIniPago"] = data.FechaInicialPago;
            rObj["feFinPago"] = data.FechaFinalPago;
            rObj["numDiasPagados"] = data.NumDiasPagados;
            rObj["totalPercep"] = data.TotalPercepciones;
            rObj["totalDeducc"] = data.TotalDeducciones;
            rObj["totalOtrosPagos"] = data.TotalOtrosPagos;
            rObj["subtotal"] = data.SubTotal;
            rObj["total"] = data.Total;
            rObj["moneda"] = data.Moneda;
            rObj["uuid"] = data.Uuid;
            rObj["rfcEmisor"] = data.RfcEmisor;
            rObj["nombreEmisor"] = data.NombreEmisor;
            rObj["feEmisión"] = data.FechaEmision;
            
            return rObj;
          });
          setRows(reformattedTableRec);
          CR.rowSelected = reformattedTableRec;
          setLoading(false);
      } else {
        setMostrarMsg({ "showMsg": 1, "kind":"error", "mensaje": data.mensajeError}); 
          setLoading(false);  
      }
    },
    imprimirRecibo: function (uuidSelected, tipoArchivo) {
      setLoading(true);
      const cell = CR.rowSelected.find(({ uuid }) => uuid === uuidSelected);

      fetch(process.env.REACT_APP_URL_SERVICE_CFDI_DESCARGAS+"?uuid="+uuidSelected+"&tipoArchivo="+tipoArchivo, {
        method: "GET",
        headers: CR.getHeaders(),
      }).then((res) => res.json()).then((data) => {
        CR.descargar(tipoArchivo, data);
        setLoading(false);
        return false;
      });
     
    },
    descargar: function (tipoArchivo, data){
        const linkSource = `data:application/${tipoArchivo};base64,${data.data.archivo}`;
        const downloadLink = document.createElement("a");
        const fileName = data.data.nombre;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    },
    validaPermisos: () => {
      let permisoOtrosRecibos = cookies.get("modOtrosRecibos");

      if(permisoOtrosRecibos != undefined && permisoOtrosRecibos.length > 0){
        setIsOtrosRecibos((permisoOtrosRecibos[0].PerfilModuloConsulta == 1)?true:false);   
      }
    },
    rowSelected: null
  };//FIN CR

useEffect(() => {
  setRows([{}]);
  CR.validaPermisos();

}, []);

return (
  <>
    <Content>
      <Loading className={'some-class'} active={loading} withOverlay={true} />

      <Grid fullWidth>
        <Column lg={16} md={8} sm={4}>
          <h3 style={{ margin: '0 0 20px' }}>Recibos de Nómina</h3><CR.ColorHrLine color="black" />
        </Column>
        <br />
        <Column lg={16} md={8} sm={4}>
          <FormGroup legendText="">
            <Grid>
              { (isOtrosRecibos) &&
              <Column lg={4} md={4} sm={4}>
                      <TextInput
                        id="txtRFC"
                        placeholder="RFC"
                        labelText="RFC"
                        value={txtRfc}
                        onChange={(e) => setTxtRfc(e.target.value)}
                        required
                      /> 
              </Column>
              }
              <Column md={4} lg={4} sm={4}>
                <DatePicker datePickerType="range" locale="es" dateFormat="Y-m-d">
                  <DatePickerInput id={`dpStart`} placeholder="yyyy-mm-dd" labelText="Fecha pago inicial" size="md" />
                  <DatePickerInput id={`dpFinish`} placeholder="yyyy-mm-dd" labelText="Fecha pago final" size="md" />
                </DatePicker>
              </Column>
              <Column md={4} lg={4} sm={4}>
                <br />
                <Button className="custom-class"
                  onClick={() => { CR.llenarTablaRecibos() }} > Consultar </Button>
              </Column>
              <Column md={8} lg={8} sm={8}>
                  <br />
                  {(mostrarMsg.showMsg === 1) &&
                        <InlineNotification kind={mostrarMsg.kind}
                        title={mostrarMsg.mensaje}
                        lowContrast={true}
                        onClick={hideMesg} />
                  }
              </Column>
            </Grid>
          </FormGroup>
        </Column>
        <br /><br /><br />
        <Column md={16} lg={16} sm={16}>
          {/*
            rows.length > 0 ? <RecibosTable rows={rows} /> : null
          */}
          {
            <RecibosTable rows={rows} />
          }

        </Column>
      </Grid>
    </Content>
  </>
);

};

export default Recibos;
